<template>
  <input v-model="checked" type="checkbox" />
</template>

<script>
export default {
  name: 'AppCheckbox',
  props: {
    value: Boolean,
  },
  data() {
    return {
      checked: this.value,
      inner: true,
    };
  },
  watch: {
    checked(newValue) {
      if (!this.inner) {
        this.inner = true;
        return;
      }
      this.$emit('input', newValue);
    },
    value(newValue) {
      if (newValue === this.checked) {
        return;
      }
      this.inner = false;
      this.checked = newValue;
    },
  },
};
</script>

<style scoped>

</style>
